import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sv-magic-string',
  template: `
    <p>
      magic-string works!
    </p>
  `,
  styles: []
})
export class MagicStringComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
